<div class="nl-page">

  <!-- ── Cabecera ─────────────────────────────────────────── -->
  <div class="nl-header">
    <div class="nl-header__left">
      <div class="nl-header__icon">
        <mat-icon>notifications</mat-icon>
      </div>
      <div>
        <h1 class="nl-header__title">
          Notificaciones
          <span class="nl-badge" *ngIf="ready && unreadCount > 0">{{ unreadCount }}</span>
        </h1>
        <p class="nl-header__sub">Tus avisos, alertas y mensajes del sistema</p>
      </div>
    </div>
  </div>

  <!-- ── Loading ───────────────────────────────────────────── -->
  <div class="nl-loading" *ngIf="!ready">
    <div class="nl-loading__icon-wrap"><mat-icon>notifications</mat-icon></div>
    <div class="nl-loading__dots"><span></span><span></span><span></span></div>
    <p class="nl-loading__text">Cargando notificaciones…</p>
  </div>

  <ng-container *ngIf="ready">

    <!-- ── Empty state ──────────────────────────────────────── -->
    <div class="nl-empty" *ngIf="empty">
      <div class="nl-empty__art"><mat-icon>notifications_none</mat-icon></div>
      <h2 class="nl-empty__title">Sin notificaciones</h2>
      <p class="nl-empty__sub">No tienes ninguna notificación por el momento.</p>
    </div>

    <!-- ── Barra de acciones bulk ────────────────────────────── -->
    <div class="nl-bulk-bar" *ngIf="!empty">
      <mat-checkbox
        [checked]="selectedUids.length === dataSource.length && dataSource.length > 0"
        [indeterminate]="hasSelected && selectedUids.length < dataSource.length"
        (change)="toggleSelectAll()"
        color="primary">
        <span class="nl-bulk-bar__label">
          {{ hasSelected ? selectedUids.length + ' seleccionadas' : 'Seleccionar todo' }}
        </span>
      </mat-checkbox>

      <div class="nl-bulk-bar__actions" *ngIf="hasSelected">
        <button mat-stroked-button (click)="changeStatus(selectedUids); selectedUids = []">
          <mat-icon>drafts</mat-icon> Marcar leídas
        </button>
        <button mat-stroked-button class="nl-btn-danger" (click)="delete(selectedUids); selectedUids = []">
          <mat-icon>delete</mat-icon> Borrar
        </button>
      </div>
    </div>

    <!-- ── Lista de notificaciones ───────────────────────────── -->
    <div class="nl-list" *ngIf="!empty">
      <div *ngFor="let n of dataSource; trackBy: trackByIndex"
           class="nl-item"
           [class.nl-item--unread]="!n.readed"
           [class.nl-item--selected]="isSelected(n.uid)"
           [class.nl-item--info]="n.type === 'Informativo'"
           [class.nl-item--success]="n.type === 'Exito'"
           [class.nl-item--warning]="n.type === 'Alerta'"
           [class.nl-item--error]="n.type === 'Error'">

        <!-- Checkbox -->
        <mat-checkbox [checked]="isSelected(n.uid)" (change)="toggleSelect(n.uid)" color="primary"
                      class="nl-item__check"></mat-checkbox>

        <!-- Icono tipo -->
        <div class="nl-item__icon">
          <mat-icon *ngIf="n.type === 'Informativo'">info</mat-icon>
          <mat-icon *ngIf="n.type === 'Exito'">check_circle</mat-icon>
          <mat-icon *ngIf="n.type === 'Alerta'">warning</mat-icon>
          <mat-icon *ngIf="n.type === 'Error'">error_outline</mat-icon>
          <mat-icon *ngIf="!n.type">notifications</mat-icon>
        </div>

        <!-- Contenido -->
        <div class="nl-item__body" (click)="goTo(n.uid)" [class.nl-item__body--link]="n.url">
          <div class="nl-item__top">
            <span class="nl-item__title">{{ n.title }}</span>
            <span class="nl-item__unread-dot" *ngIf="!n.readed"></span>
          </div>
          <p class="nl-item__message">{{ n.body }}</p>
          <div class="nl-item__meta">
            <span class="nl-item__origin" *ngIf="n.origin">
              <mat-icon>person_outline</mat-icon>{{ n.origin }}
            </span>
            <span class="nl-type-badge nl-type-badge--{{ n.type | lowercase }}">{{ n.type }}</span>
            <span class="nl-item__date">{{ n.creationDate }}</span>
          </div>
        </div>

        <!-- Menú acciones -->
        <button mat-icon-button [matMenuTriggerFor]="menu" class="nl-item__menu" matTooltip="Acciones">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="goTo(n.uid)" *ngIf="n.url">
            <mat-icon>open_in_new</mat-icon><span>Ir</span>
          </button>
          <button mat-menu-item (click)="changeStatus(n.uid)">
            <mat-icon>{{ n.readed ? 'mail' : 'drafts' }}</mat-icon>
            <span>{{ n.readed ? 'Marcar no leída' : 'Marcar leída' }}</span>
          </button>
          <button mat-menu-item *ngIf="isConciliationNotification(n.body)" (click)="downloadConciliationReport(n.uid)">
            <mat-icon>file_download</mat-icon><span>Descargar reporte</span>
          </button>
          <mat-divider></mat-divider>
          <button mat-menu-item class="nl-menu-danger" (click)="delete(n.uid)">
            <mat-icon>delete</mat-icon><span>Borrar</span>
          </button>
        </mat-menu>

      </div>
    </div>

  </ng-container>
</div>
